import { Text } from "@/components/ui/text";
import { View } from "@/components/ui/view";
import { FlatList } from "react-native-gesture-handler";
import React, { useEffect, useState } from 'react';
import Footer from "@/components/basic/Footer";
import i18n from "i18n-js";
import WorkflowListElement from "@/components/workflow/WorkflowListElement";
import { useSelector } from 'react-redux';
import useIsMounted from '@/hooks/mounted';
import ModalConfirm from "@/components/basic/ModalConfirm";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export default function SharedWorkflows({ navigation, route, updateChilds, updateContactChilds }) {
    const { title, info, contact, sharedTo, sharedFrom, channel, isEdit } = route.params

    const workflows = useSelector((state) => state.workflows)
    const mounted = useIsMounted()
    const insets = useSafeAreaInsets()

    const [actWorkflows, setActWorkflows] = useState(contact ? sharedTo : channel.workflows?.filter(id => id && workflows[id]))
    const [showModal, setShowModal] = useState(false)
    const [action, setAction] = useState()
    const [data, setData] = useState(() => {
        if (isEdit) {
            return Object.keys(workflows).filter(taskid => taskid.length > 2 && workflows[taskid].owned && !workflows[taskid].deleted).sort((a, b) => {
                const aTitle = (workflows[a].title || '').toLowerCase()
                const bTitle = (workflows[b].title || '').toLowerCase()
                return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
            })
        } else {
            if (contact) {
                console.log(sharedFrom, sharedTo)
                let list = [{ id: 'T1', info: i18n.t('contactManagement.requestFrom', { num: sharedFrom.length }) }]
                list = list.concat(sharedFrom.sort((a, b) => {
                    const aTitle = (a.title || '').toLowerCase()
                    const bTitle = (b.title || '').toLowerCase()
                    return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
                }))
                list.push({ id: 'T2', info: i18n.t('contactManagement.requestTo', { num: sharedTo.length }) })
                list = list.concat(sharedTo.sort((a, b) => {
                    const aTitle = (workflows[a].title || '').toLowerCase()
                    const bTitle = (workflows[b].title || '').toLowerCase()
                    return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
                }))
                return list
            } else {
                return actWorkflows.sort((a, b) => {
                    const aTitle = (workflows[a].title || '').toLowerCase()
                    const bTitle = (workflows[b].title || '').toLowerCase()
                    return aTitle > bTitle ? 1 : aTitle < bTitle ? -1 : 0
                })
            }
        }
    })

    const actions = [
        { icon: 'keyboard-arrow-left', text: 'footer.back', component: 'BACK' },
        { icon: 'home', text: 'footer.home', component: 'Home' },
        isEdit ? { icon: 'check', text: 'footer.finish', component: 'BACK' } : { icon: '' }
    ]

    useEffect(() => {
        navigation.setOptions({ title: title, info: info })
    }, [])

    const onSelect = (taskid, isSelected) => {
        if (isSelected) {
            setActWorkflows(prev => {
                const next = [...prev]
                next.push(taskid)
                return next
            })
        } else {
            setActWorkflows(prev => {
                const next = prev.filter(id => id != taskid)
                return next
            })
        }
    }

    const onContactSelect = (taskid, isSelected) => {
        if (isSelected) {
            setActWorkflows(prev => {
                const next = [...prev]
                next.push(taskid)
                return next
            })
        } else {
            setActWorkflows(prev => {
                const next = prev.filter(id => id != taskid)
                return next
            })
        }
    }

    useEffect(
        () => {
            return navigation.addListener('beforeRemove', (e) => {
                const noneRemoved = (contact ? sharedTo : channel.workflows).filter(workflow => !actWorkflows.includes(workflow)).length == 0
                // if there are no deletions
                if (!isEdit || noneRemoved) {
                    return;
                }
                // Prevent default behavior of leaving the screen
                e.preventDefault()
                // Prompt the user before leaving the screen
                setAction(e.data.action)
                setShowModal(true)
            })
        },
        [navigation, actWorkflows]
    )

    useEffect(() => {
        return () => {
            if (!mounted()) {
                if (updateChilds) {
                    updateChilds(null, actWorkflows)
                }
                if (updateContactChilds) {
                    updateContactChilds(null, actWorkflows)
                }
            }
        };
    }, [mounted])

    const closeModal = (confirmed) => {
        setShowModal(false)
        if (confirmed) {
            navigation.dispatch(action)
        } else {
            // reset selections
            setActWorkflows(contact ? sharedTo : channel.workflows)
        }
    }

    const renderItemEdit = ({ item, index }) => {
        return <WorkflowListElement key={item} navigation={navigation} taskid={item} showProgress={false} onDelete={false} disabled={true} selected={actWorkflows.includes(item)} onSelect={contact ? onContactSelect : onSelect} />
    }

    const renderItem = ({ item, index }) => {
        return item.info ?
            <Text key={'T' + index} className="px-5 text-xl text-secondary-900">{item.info}</Text>
            : item.id ? <WorkflowListElement key={item.id} navigation={navigation} taskid={item.id} showProgress={false} onDelete={false} disabled={true} />
                : <WorkflowListElement key={item} navigation={navigation} taskid={item} showProgress={false} onDelete={false} disabled={true} />;
    }

    return (
        <View className="bg-secondary-50 flex-1">
            <Text className="px-3 py-3 text-2xl text-secondary-900">{i18n.t(isEdit ? 'contact.workflows' : (contact ? 'contact.sharedWorkflows' : 'channel.sharedWorkflows'), { num: actWorkflows.length })}</Text>
            <FlatList
                contentContainerStyle={{ paddingBottom: 70 + insets.bottom }}
                data={data}
                renderItem={isEdit ? renderItemEdit : renderItem}
                keyExtractor={item => item?.id || item}
            />
            <ModalConfirm showModal={showModal} closeModal={closeModal} title='shareWorkflow.title' text={contact ? 'shareWorkflow.textContactUnshare' : 'shareWorkflow.textChannelUnshare'} buttonOk='shareWorkflow.ok' />
            <Footer navigation={navigation} actions={actions} />
        </View>
    );
}
